// src/hooks/useIsDesktop.js
import { useEffect, useState } from "react";

export default function useIsDesktop() {
  const match = () =>
    typeof window !== "undefined" &&
    window.matchMedia("(min-width: 768px)").matches;

  const [isDesktop, setIsDesktop] = useState(match);

  useEffect(() => {
    const mql = window.matchMedia("(min-width: 768px)");
    const handler = (e) => setIsDesktop(e.matches);
    mql.addEventListener?.("change", handler) || mql.addListener(handler);
    return () =>
      mql.removeEventListener?.("change", handler) || mql.removeListener(handler);
  }, []);

  return isDesktop;
}
